import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Color } from '../../../../../assets/color';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PersonSvg } from '../../../../../assets/svg';
import RouteHeader from '../../../../../components/common/RouteHeader';
import DatatableHeading from '../../../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../../../components/datatable/DatatableWithSearch';
import * as AdminActions from '../../../../../redux/actions/adminAction';

const PartnerAffiliates = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParam] = useSearchParams();
    const partnerId = searchParam.get('id') || '';
    const partner_name = searchParam.get('name') || '';
    const { affiliatesByPartnerIdData } = useSelector(state => state?.adminReducer);
    const columns = [
        { name: 'S.No.', selector: row => affiliatesByPartnerIdData?.indexOf(row) + 1, width: '80px' },
        { name: 'Affiliate Name', selector: row => row?.partner_name || '—' },
        { name: 'Reg.No.', selector: row => row?.registration_number || '—' },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '...' },
        { name: 'Email ID', selector: row => row?.email || '...', width: '250px' },
        { name: 'Password', selector: row => row?.password || '...' },
        { name: 'Wallet Balance', selector: row => row?.report_wallet_balance || '...' },
        { name: 'Status', selector: row => row?.is_active ? 'Active' : 'Inactive' },
        {
            name: 'Customers',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div onClick={() => navigate(`/management/admins/partner/affiliates/customers?name=${row?.partner_name}&id=${row?.registration_number}`)} style={{ cursor: "pointer" }}><PersonSvg /></div>
                </div>
            ),
            right: 'true'
        },
    ];
    useEffect(() => {
        dispatch(AdminActions.getAffiliatesByPartnerId({ partnerId }));
    }, []);
    return (
        <>
            <RouteHeader title={`${partner_name} – Affiliates`} sub_title="View affiliates under this partner" />
            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={`Affiliates under ${partner_name}`} sub_title="Click the person icon to view affiliate's customers" />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={affiliatesByPartnerIdData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    );
};
export default PartnerAffiliates;
